import React, { useState } from "react";
import AddPakat from "../AddPakat/AddPakat";
import EditPakat from "../EditPakat/EditPakat";
import { AiOutlineFileAdd, AiTwotoneEdit } from "react-icons/ai";

const ManagePakat = () => {
  const [state, setState] = useState("add");

  return (
    <>
      <section dir="rtl" className="bg-lightPrimary dark:bg-darkPrimary ">
        <div className="grid min-h-[calc(100vh-128px)] max-h-[calc(100vh-128px)] overflow-auto place-items-center">
          <div className="bg-lightSecondary dark:bg-darkSecondary rounded-2xl  shadow-2xl p-4 m-5 w-11/12 sm:w-fit">
            <div
              className="flex  justify-center rounded-md items-center mb-8"
              role="group"
            >
              <button
                type="button"
                onClick={() => {
                  setState("add");
                }}
                className={`px-4 py-2 text-lg font-medium  border border-gray-200 rounded-r-md focus:z-10 focus:ring-2 
                ${
                  state == "add"
                    ? "bg-green-800 text-darkTextPrimary"
                    : "dark:bg-darkPrimary dark:text-white text-gray-900 bg-lightPrimary"
                } dark:hover:text-white  dark:focus:text-white`}
              >
                <div className="flex">
                  <AiOutlineFileAdd className="ml-1 mt-1" />
                  افزودن
                </div>
              </button>
              <button
                type="button"
                onClick={() => {
                  setState("edit");
                }}
                className={`px-4 py-2 text-lg font-medium border border-gray-200 rounded-l-lg focus:z-10 
                ${
                  state == "edit"
                    ? "bg-yellow-400  text-darkTextPrimary"
                    : "dark:bg-darkPrimary dark:text-white text-gray-900 bg-lightPrimary"
                } dark:hover:text-white`}
              >
                <div className="flex">
                  <AiTwotoneEdit className="ml-1 mt-1" />
                  ویرایش
                </div>
              </button>
            </div>
            {state == "add" ? <AddPakat /> : <EditPakat />}
          </div>
        </div>
      </section>
    </>
  );
};

export default ManagePakat;
